import { Link } from 'react-router';
import { Check } from '@/icons';
import { formatEur, type PricingTier } from '@/data/pricing';
import { cn } from '@/lib/cn';

type Props = {
  tier: PricingTier;
};

export function PricingCard({ tier }: Props) {
  const { name, priceFrom, summary, features, highlighted } = tier;
  return (
    <article
      className={cn(
        'flex flex-col p-8 md:p-10 border transition-all duration-300',
        highlighted
          ? 'border-accent bg-surface-raised relative'
          : 'border-border bg-surface hover:bg-surface-raised hover:border-border-strong',
      )}
    >
      {highlighted && (
        <span className="mono-meta text-accent absolute -top-3 left-6 bg-bg px-2">
          Most picked
        </span>
      )}
      <h3 className="font-display text-3xl font-medium">{name}</h3>
      <p className="text-ink-secondary mt-3 leading-relaxed">{summary}</p>
      <div className="mt-8 mb-6 flex items-baseline gap-2">
        <span className="mono-meta text-ink-muted">from</span>
        <span className="font-display text-5xl font-semibold tracking-tight">
          {formatEur(priceFrom)}
        </span>
      </div>
      <div className="mono-meta text-ink-muted mb-6">Timeline · {tier.timeline}</div>
      <ul className="flex flex-col gap-3 mt-2 mb-8">
        {features.map((feature) => (
          <li key={feature} className="flex gap-3 text-ink-secondary">
            <Check className="w-5 h-5 text-accent shrink-0 mt-0.5" />
            <span className="text-sm">{feature}</span>
          </li>
        ))}
      </ul>
      <Link
        to="/contact"
        className={cn(
          'mt-auto inline-flex justify-center py-3 px-6 font-sans font-semibold transition-all duration-200',
          highlighted
            ? 'bg-accent text-bg rounded-full hover:bg-accent-hover hover:scale-[1.02]'
            : 'border border-ink-primary hover:bg-ink-primary hover:text-bg',
        )}
      >
        Start this tier
      </Link>
    </article>
  );
}
